import {
  Categories,
  Address,
  Users,
  Settings,
  UsersProfils,
} from './';

import { 
  Create as CreateEvent,
  Update as UpdateEvent,
  List as ListEvent,
  Top as TopEvent,
  UsersRegistration ,
  UsersPresence
} from './events';

import { by } from '../../common/routerAccess';

export default {
  path: 'admin',
  name: 'Admin',
  access: by.only.USER,
  childRoutes: [
    //{ path: '', name: 'Dashboard', component: Home, visible: true, isIndex: true },//remove isIndexTrue one line below
    { path: 'events', name: 'Evénements', component: ListEvent, visible: true, isIndex: true, access: by.only.ADMIN},
    { path: 'events/top', name: 'Evénements à la une', component: TopEvent, visible: true, access: by.only.ADMIN },
    { path: 'events/create', name: 'Ajouter un événment', component: CreateEvent, access: by.only.ADMIN },
    { path: 'events/update/:id', name: 'MAJ événement', component: UpdateEvent, access: by.only.ADMIN },
    { path: 'events/registration/:id', name: 'User Registration', component: UsersRegistration, access: by.only.ADMIN },
    { path: 'events/presence/:id', name: 'User presence', component: UsersPresence },
    { path: 'categories', name: 'Categories', component: Categories, visible: true, access: by.only.ADMIN },
    { path: 'address', name: 'Address', component: Address, access: by.only.ADMIN },
    { path: 'users', name: 'Users', component: Users, visible: true, access: by.only.ADMIN },
    { path: 'settings', name: 'Settings', component: Settings, visible: true, access: by.only.ADMIN },
    { path: 'users/:id', name: 'UsersProfils', component: UsersProfils, access: by.only.ADMIN },
  ],
};



// WEBPACK FOOTER //
// ./src/features/admin/route.js